import dedent from 'ts-dedent'
import {
  Provider,
  WorkflowComponentCheckInputValuesParams,
  WorkflowComponentCodeParams,
  WorkflowComponentParamType,
  WorkflowComponentValue,
  WorkflowParameterValueErrorType
} from '../types'
import { isExpressionValue, isSingleVariable } from '../utils'
import { SelectSameSchemaWorkflowComponent } from './common/selectsameschemacomponent'

class Limit extends SelectSameSchemaWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.limit',
        group: 'Data Preparation',
        title: 'Limit',
        description: `
      This component creates a new table with only the N first rows of the input table.
      `,
        starred: true
      },
      [
        {
          name: 'source',
          type: WorkflowComponentParamType.InputTable,
          title: 'Source table'
        },
        {
          name: 'limit',
          type: WorkflowComponentParamType.Number,
          title: 'Number of rows',
          min: 1,
          default: 10
        }
      ]
    )
    this.requiresDynamicSQL = true
  }

  checkInputValues({
    params,
    resolvedParamValues,
    connection,
    dryRun,
    schemas,
    variables
  }: WorkflowComponentCheckInputValuesParams) {
    const problems = super.checkInputValues({
      params,
      resolvedParamValues,
      connection,
      dryRun,
      schemas,
      variables
    })
    if (
      params.limit &&
      isExpressionValue(params.limit as WorkflowComponentValue) &&
      !isSingleVariable(params.limit as WorkflowComponentValue)
    ) {
      problems.push({
        parameter: 'limit',
        type: WorkflowParameterValueErrorType.WrongValue,
        message: 'Expressions are not allowed in this component. Only simple variables are supported'
      })
    }
    return problems
  }

  getInnerSql({ params, connection }: WorkflowComponentCodeParams) {
    const limitStr = `${params.limit}`.replace(/[()]/g, '') // remove parentheses if expression
    const limit = Math.floor(Number(limitStr))
    if (connection.type === Provider.DatabricksRest) {
      return dedent`SELECT /*+ REPARTITION(40) */
                *
              FROM ${connection.quoteName(params.source as string)}
              LIMIT ${limit}`
    } else if (connection.type === Provider.Oracle) {
      return dedent`SELECT *
              FROM ${connection.quoteName(params.source as string)}
              FETCH FIRST ${limit} ROWS ONLY`
    } else {
      return dedent`SELECT *
              FROM ${connection.quoteName(params.source as string)}
              LIMIT ${limit}`
    }
  }
  supportedProviders(): Provider[] {
    return [
      Provider.BigQuery,
      Provider.Postgres,
      Provider.Redshift,
      Provider.Snowflake,
      Provider.DatabricksRest,
      Provider.Oracle
    ]
  }
}

export { Limit }
